interface DropdownItemParams {
	label: string;
	value: string;
}

export default class DropdownItem {
	public label: string;
	public value: string;

	public constructor(params: DropdownItemParams) {
		this.label = params.label;
		this.value = params.value;
	}
}